import { Datalayers } from './Datalayers';
import { Modal } from './modals';

const SELECTORS = {
    COMPONENT: '.js-lazyload-external-video',
    LINK: '.js-lazyload-external-video-link',
    VIDEO_CONTAINER: '.js-lazyload-external-video-container',
    MODAL: '.js-lazy-load-external-video-modal',
    THUMBNAIL: '.js-lazyload-external-video-thumbnail',
};

const COLOR_MODIFIERS = ['pink', 'blue', 'green', 'yellow'];

export function lazyLoadExternalVideo() {
    const externalVideos = [...document.querySelectorAll(SELECTORS.COMPONENT)];
    const datalayers = new Datalayers();
    let index = 0;

    if (externalVideos) {
        externalVideos.forEach((externalVideo) => {
            const link = externalVideo.querySelector(SELECTORS.LINK);
            const modal = new Modal({
                modal: externalVideo.querySelector(SELECTORS.MODAL),
                hook: link,
                cbOnClose: () => {
                    removeVideo(externalVideo);
                },
            });
            const thumbNailImage = link.querySelector(SELECTORS.THUMBNAIL);

            externalVideo.classList.add(`lazyload-external-video--${COLOR_MODIFIERS[index]}`);

            index = index === COLOR_MODIFIERS.length - 1 ? 0 : index + 1;

            if (thumbNailImage) {
                getBestQualityThumbnailUrl(link.dataset.videoId).then((url) => {
                    thumbNailImage.src = url;
                });
            }

            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (!modal.isOpen) {
                    appendVideo(externalVideo, link);
                    datalayers.pushData({
                        event: 'video',
                        eventAction: 'play',
                        videoUrl: `https://www.youtube.com/watch?v=${link.dataset.videoId}`,
                    });
                }

                modal.showModal();
            });
        });
    }
}

function appendVideo(externalVideo, link) {
    const { provider, videoId } = link.dataset;
    const videoContainer = externalVideo.querySelector(SELECTORS.VIDEO_CONTAINER);
    const template = createTemplate(provider, videoId);

    videoContainer.appendChild(template);
}

function removeVideo(externalVideo) {
    const videoContainer = externalVideo.querySelector(SELECTORS.VIDEO_CONTAINER);
    const iframe = videoContainer.querySelector('iframe');

    if (iframe) {
        iframe.parentNode.removeChild(iframe);
    }
}

function createTemplate(provider, videoId) {
    let template;
    let url;
    let time;

    switch (provider) {
        case 'youtube':
            if (videoId.includes('?t=')) {
                time = videoId.split('=').pop();
                // eslint-disable-next-line max-len
                url = `//www.youtube.com/embed/${videoId}?title=0&amp;byline=0&amp;portrait=0;&amp;badge=0&amp;autoplay=1&amp;start=${time}`;
            } else {
                // eslint-disable-next-line max-len
                url = `//www.youtube.com/embed/${videoId}?title=0&amp;byline=0&amp;portrait=0;&amp;badge=0&amp;autoplay=1`;
            }
            break;

        case 'vimeo':
            url = `//player.vimeo.com/video/${videoId}?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autoplay=1`;
            break;

        default:
            url = '';
            break;
    }

    if (url !== '') {
        template = document.createElement('iframe');
        template.setAttribute('src', url);
        template.setAttribute('webkitallowfullscreen', 'true');
        template.setAttribute('mozallowfullscreen', 'true');
        template.setAttribute('allowfullscreen', 'true');
        template.style.width = `${100}%`;
        template.style.height = `${100}%`;
    } else {
        template = '<p>Sorry, this provider is not supported yet.</p>';
    }

    return template;
}

function getBestQualityThumbnailUrl(id) {
    const resolution = [
        'maxresdefault',
        'sddefault',
        'mqdefault',
        'hqdefault',
        'default',
    ];

    const imageUrls = [];

    const checkImage = (image) =>
        new Promise((resolve) => {
            const img = new Image();

            img.onload = () => {
                resolve({ image, status: 'ok' });
            };
            img.onerror = () => resolve({ image, status: 'error' });

            img.src = image.url;
        });

    const loadImg = (...images) => Promise.all(images.map(checkImage));

    resolution.forEach((size) => {
        const url = `//img.youtube.com/vi/${id}/${size}.jpg`;
        const imageObject = {};
        imageObject.quality = size;
        imageObject.url = url;
        imageUrls.push(imageObject);
    });

    return loadImg(...imageUrls)
        .then((values) => values[0].image.url);
}
